import { laborHoursConstant } from './constant';

export const getAllLaborHours = (payload: any) => {
  return {
    type: laborHoursConstant.GET_LABOR_HOURS_REQUEST,
    payload,
  };
};
export const getAllLaborCodes = () => {
  return {
    type: laborHoursConstant.GET_LABOR_CODES_REQUEST,
  };
};

export const addLaborHoursAction = (payload: any) => {
  return {
    type: laborHoursConstant.ADD_LABOR_HOURS_REQUEST,
    payload,
  };
};

export const editLaborHoursAction = (payload: any) => {
  return {
    type: laborHoursConstant.EDIT_LABOR_HOURS_REQUEST,
    payload,
  };
};

export const getLocationTypeLaborHr = () => {
  return {
    type: laborHoursConstant.GET_LOCATION_TYPE_REQUEST,
  };
};

export const resetAddLaborHoursAction = () => {
  return {
    type: laborHoursConstant.ADD_LABOR_HOURS_RESET,
  };
};

export const resetEditLaborHoursAction = () => {
  return {
    type: laborHoursConstant.EDIT_LABOR_HOURS_RESET,
  };
};

export const deleteLaborHoursAction = (payload: any) => {
  return {
    type: laborHoursConstant.DELETE_LABOR_HOURS_REQUEST,
    payload,
  };
};

export const resetDeleteLaborHoursAction = () => {
  return {
    type: laborHoursConstant.DELETE_LABOR_HOURS_RESET,
  };
};
